import api from "services/api";

// Get all leaves
export const getMyLeaves = async () => {
  return api.get("/v1/api/admin/leaves");
};

// approve or reject (update)
export const updateLeaveAction = async (leaveId, actionData) => {
  return api.put(`/v1/api/admin/leave-action/${leaveId}`, actionData);
};
